import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { useGetWorkshopQuery } from '../../../../../../redux/services/fo_workshops.jsx';
import {
  useGetDatesQuery,
  useSignIntoDateMutation,
} from '../../../../../../redux/services/fo_dates.jsx';
import { Spinner } from '../../../../../common/index.jsx';
import WorkshopsDetail from '../../../../../common/FriOpen/Workshops/WorkshopsDetail.jsx';
import { ROLE_FRI_OPEN_PARTICIPANT } from '../../../../../../utils/constants/roles.js';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import useUserHasRole from '../../../../../../hooks/useUserHasRoles.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages';

const FoWorkshopDetailPage = () => {
  const { t } = useTranslation();
  const { workshopId } = useParams();
  const { successMessage } = useToastMessages();

  const lastActionRef = useRef(null);
  const isFriOpenParticipant = useUserHasRole(ROLE_FRI_OPEN_PARTICIPANT);
  const navigate = useNavigate();

  const { data: workshop, isLoading: isLoadingWorkshop } =
    useGetWorkshopQuery(workshopId);

  const {
    data: dates,
    isLoading: isLoadingDates,
    refetch: refetchDates,
  } = useGetDatesQuery(workshopId, {
    skip: !isFriOpenParticipant,
  });

  const [signIntoDate, { isSuccess }] = useSignIntoDateMutation();

  const handleSign = (record, action) => {
    lastActionRef.current = action;
    signIntoDate({
      dateId: record.id,
      action,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      if (lastActionRef.current === 'register') {
        successMessage({
          message: 'Boli ste úspešne prihlásený na termín',
        });
      } else if (lastActionRef.current === 'unregister') {
        successMessage({
          message: 'Boli ste odhlásený z termínu',
        });
      }
      refetchDates();
    }
  }, [isSuccess]);

  return isLoadingWorkshop || isLoadingDates ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('FRI Akcia - detail seminára')}
        backUrl={-1}
        backUrlTooltip={t('Späť')}
      />
      <div style={{ margin: '10px' }}>
        <WorkshopsDetail
          workshop={workshop}
          dates={isFriOpenParticipant ? dates : null}
          onRowClick={(date) => {
            navigate(routes.cmsFoDatesDetail(date.id));
          }}
          onDetailClick={(date) => {
            navigate(routes.cmsFoDatesDetail(date.id));
          }}
          onSignOnClick={(record) => handleSign(record, 'register')}
          onUnsignOnClick={(record) => handleSign(record, 'unregister')}
        />
      </div>
    </>
  );
};

export default FoWorkshopDetailPage;
